import React, { useEffect, useState } from 'react';
import { adminApi } from '../services/api';

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [creating, setCreating] = useState(false);
  const [form, setForm] = useState({ username: '', email: '', profile: 'admin', password: '' });

  const load = () => {
    setLoading(true);
    adminApi.listUsers()
      .then((r) => setUsers(r.users || []))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  };
  useEffect(load, []);

  const create = async (e) => {
    e.preventDefault();
    if (!form.username || !form.password) return;
    setCreating(true);
    try {
      await adminApi.createUser(form);
      setForm({ username: '', email: '', profile: 'admin', password: '' });
      load();
    } catch (err) { alert(err.message); }
    finally { setCreating(false); }
  };

  const disable = async (userId) => {
    if (!window.confirm('Disable this user?')) return;
    try { await adminApi.disableUser(userId); load(); } catch (err) { alert(err.message); }
  };

  const resetPw = async (userId) => {
    const pw = window.prompt('New password (min 12 chars):');
    if (!pw) return;
    try { await adminApi.resetPassword(userId, pw); alert('Password reset'); } catch (err) { alert(err.message); }
  };

  if (loading) return <div className="card"><span className="spinner" /></div>;
  if (error) return <div className="card"><span className="badge danger">Error</span> {error}</div>;

  return (
    <div className="stack-lg">
      <h1 className="h1">Ops users</h1>

      <div className="card" style={{ padding: 0 }}>
        <table className="table">
          <thead>
            <tr><th>Username</th><th>Email</th><th>Profile</th><th>Status</th><th>Last login</th><th></th></tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.ROWID}>
                <td>{u.username}</td>
                <td className="small muted">{u.email}</td>
                <td><span className="badge">{u.profile}</span></td>
                <td><span className={`badge ${u.status === 'active' ? 'success' : 'danger'}`}>{u.status}</span></td>
                <td className="small muted">{u.lastLoginAt ? new Date(u.lastLoginAt).toLocaleString() : '—'}</td>
                <td>
                  <button className="btn ghost small" onClick={() => resetPw(u.ROWID)}>Reset password</button>
                  {u.status === 'active' ? <button className="btn ghost small" onClick={() => disable(u.ROWID)}>Disable</button> : null}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="card">
        <h2 className="h2">Add user</h2>
        <form className="stack" onSubmit={create}>
          <div>
            <label className="label">Username</label>
            <input className="input" value={form.username} onChange={(e) => setForm({ ...form, username: e.target.value })} required />
          </div>
          <div>
            <label className="label">Email</label>
            <input className="input" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
          </div>
          <div>
            <label className="label">Profile</label>
            <select className="input" value={form.profile} onChange={(e) => setForm({ ...form, profile: e.target.value })}>
              <option value="admin">admin</option>
              <option value="compliance_reviewer">compliance_reviewer</option>
            </select>
          </div>
          <div>
            <label className="label">Temporary password</label>
            <input className="input" type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} minLength={12} required />
          </div>
          <button className="btn" type="submit" disabled={creating}>{creating ? 'Creating…' : 'Create user'}</button>
        </form>
      </div>
    </div>
  );
}
